import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../helper/api";

export const getReferralEarning = createAsyncThunk(
  "getReferralEarning",
  async (payload, thunkAPI) => {
    try {
      const response = await api.get("referral-detail");
      return response.data;
    } catch (error) {
      console.warn(error, "error")
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.response?.data?.message || "Unknown error",
      });
    }
  }
);

const getReferralEarningSlice = createSlice({
  name: "getReferralEarning",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getReferralEarning.pending, (state) => {
        state.loading = true;
      })
      .addCase(getReferralEarning.fulfilled, (state, action) => {
          

        state.loading = false;
        state.data = action.payload.response;
      })
      .addCase(getReferralEarning.rejected, (state, action) => {
       
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default getReferralEarningSlice.reducer;
